import amapi from 'Api/amapi'

const initialState = () => ({
  modal: false
})

const state = initialState

const getters = {
  modal: state => state.modal,
}

const mutations = {
  POPULATE_MODAL (state, bool) {
    state.modal = bool
  },
  CLEAR_IDLE_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async sessionPing ({ commit }, activity) {
    try {
      const response = await amapi.makecall('ping', { activity })

      commit('notifications/POPULATE_NOTIFICATIONS', response.notifications, { root: true })

      return response
    } catch (e) {
      throw e
    }
  },
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
